angular.module('salesPath2')
  .service('applicationDisabledHelper', ['sp2CommonHelper',
    function(sp2CommonHelper) {
      var ApplicationDisabledHelper = function() {

        //ustawienia modali
        this.modals = {};

        this.modals.applicationDisabledModal = {
          settings: {
            treatLabelAsI18nCode: true,
            title: 'sp2.modal.apk.title',
            size: 'sm',
            okBtnName: 'sp2.modal.close',
            cancelBtnName: false
          }
        };

        this.modals.applicationBlockedModal = {
          settings: {
            treatLabelAsI18nCode: true,
            title: 'sp2.modal.apk.title',
            size: 'sm',
            okBtnName: 'sp2.modal.close',
            cancelBtnName: false,
            keyboard: false
          }
        };

        /**
         * Wyświetlenie modala
         */
        this.showModal = function(modal) {
          sp2CommonHelper.showModal(modal);
        };
      };

      return new ApplicationDisabledHelper();
    }
  ]);
